// src/data/reviews.js
import { setWithExpiry, getWithExpiry } from '../utils/storage';

// key name for localStorage
const STORAGE_KEY = 'gameReviews';
const TTL_MINUTES = 1440; // 1 day expiration

const defaultReviews  = [
  {
    id: '1',
    title: 'Starlight Odyssey',
    platform: 'PC',
    genre: 'Simulation',
    developer: 'Lemon',
    publisher: ' ',
    rating: 4.7,
    date: '2025-9-25',
    summary: 'Traversel acrross the Universe is unmatched - gameplay mechanics are solid.',
    body: 'Full review body text...',
    altDesc: 'A group of astronauts in futuristic white and yellow space suits stand on an alien world with a massive moon in the background and tall crystalline structures around them.',
    imageUrl: '/starlight-odyssey.webp'
  },
  {
    id: '2',
    title: 'Neon Drift 2099',
    platform: 'PlayStation',
    genre: 'Racing',
    developer: 'Logan',
    publisher: ' ',
    rating: 4.0,
    date: '2025-07-01',
    summary: 'Fast arcade-style racing, great drifting, but somewhat shallow career mode.',
    body: 'Full review body text...',
    altDesc: 'A lone figure wearing a coat walks down a neon-lit cyberpunk city street at night, surrounded by futuristic cars and glowing signs.',
    imageUrl: '/neon-drift-2099.webp'
  },
  {
    id: '3',
    title: 'Pocket Botanica',
    platform: 'Nintendo',
    genre: 'Simulation',
    developer: 'Maya',
    publisher: ' ',
    rating: 3.5,
    date: '2025-04-12',
    summary: 'Charming garden sim with relaxing mechanics — some progression pacing issues.',
    body: 'Full review body text...',
    altDesc: 'An adventurer with a backpack looks out over a bright, lush countryside with farms, rivers, and cottages stretching into the distance.',
    imageUrl: '/pocket-botanica.webp'
  },
  {
    id: '4',
    title: 'The King\'s Road',
    platform: 'Nintendo',
    genre: 'Simulation',
    developer: 'Jill Joes',
    publisher: ' ',
    rating: 3.1,
    date: '2025-04-12',
    summary: 'Like Oregon Trail meets Medieval Times — has Glitches.',
    body: 'Full review body text...',
    altDesc: 'A pixel art scene of knights and travelers on horseback escorting a wagon through a forest at sunset, with a castle and dragon in the background.',
    imageUrl: '/the-kings-road.webp'
  },
  {
    id: '5',
    title: 'Hollow Skies: Echoes',
    platform: 'PC',
    genre: 'Action RPG',
    developer: 'Ava',
    publisher: ' ',
    rating: 4.5,
    date: '2025-08-21',
    summary: 'A moody action-RPG with tight combat and a haunting soundtrack.',
    body: 'Full review body text goes here. Discuss story, combat, visuals and replayability.',
    altDesc: 'A person wearing a red backpack stands beside a small animal in a lush green field near ancient stone ruins, looking toward distant mountains under a bright blue sky with fluffy clouds.',
    imageUrl: '/hollow-skies.webp'
  },
  {
    id: '6',
    title: 'Phantom Underground',
    platform: 'PlayStation',
    genre: 'Simulation',
    developer: 'Maya',
    publisher: ' ',
    rating: 3.4,
    date: '2025-04-12',
    summary: 'Rogue Metro like gameplay — some framerate issues.',
    body: 'Full review body text...',
    altDesc: 'Three people in rugged clothing and gas masks stand against a weathered red and beige background, suggesting a post-apocalyptic setting.',
    imageUrl: '/phantom-underground.webp'
  },
  {
    id: '7',
    title: 'Dragon\'s Fist',
    platform: 'Mobile',
    genre: 'Simulation',
    developer: 'Maya',
    publisher: ' ',
    rating: 2.4,
    date: '2025-04-12',
    summary: 'Street Fighter Copycat. Not very good.',
    body: 'Full review body text...',
    altDesc: 'Four martial artists face off in a massive arena surrounded by cheering crowds, with giant elemental beasts looming in the stormy sky above.',
    imageUrl: '/dragons-fist.webp'
  },
  {
    id: '8',
    title: 'Planitrimant',
    platform: 'Nintendo',
    genre: 'Simulation',
    developer: 'Maya',
    publisher: ' ',
    rating: 4.1,
    date: '2025-04-12',
    summary: 'A Fantastic SteamPunk styled game amazing visuals.',
    body: 'Full review body text...',
    altDesc: 'A woman wearing steampunk goggles and a leather outfit stands in a detailed fantasy cityscape beside the title Planitrimant',
    imageUrl: '/planitriment.webp'
  },
  {
    id: '9',
    title: 'Edge Rush',
    platform: 'Xbox',
    genre: 'Simulation',
    developer: 'Maya',
    publisher: ' ',
    rating: 4.2,
    date: '2025-04-12',
    summary: 'Cyberpunk shooter full of espionage and puzzles.',
    body: 'Full review body text...',
    altDesc: 'A closeup shot of a Man with red sunglasses cyberpunk-esque',
    imageUrl: '/edge-rush.webp'
  }
];

export function getReviews() {
  const cached = getWithExpiry(STORAGE_KEY);
  return cached || defaultReviews;
}

// add a new review and reset expiry timer
export function saveReview(review) {
  const reviews = getReviews();
  reviews.push({ ...review, id: Date.now().toString() });
  setWithExpiry(STORAGE_KEY, reviews, TTL_MINUTES);
}

// clear the stored data manually
export function clearReviews() {
  localStorage.removeItem(STORAGE_KEY);
}

export default defaultReviews ;